/**
 * Composant Alpine pour la recherche site front.
 * - Ouverture overlay plein écran (CTRL/CMD + K ou clic icône)
 * - Suggestions live via HTMX (debounce 300ms)
 * - Historique localStorage
 * - Submit Enter → /recherche?q=...
 */
export default function siteSearch() {
    return {
        searchOpen: false,
        query: '',
        recent: [],

        init() {
            // Safety net : restaurer le scroll au montage
            document.body.style.overflow = '';

            // Charger l'historique
            try {
                this.recent = JSON.parse(localStorage.getItem('site_recent_searches') || '[]');
            } catch (e) {
                this.recent = [];
            }

            // Raccourci clavier : Cmd/Ctrl + K
            window.addEventListener('keydown', (e) => {
                if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                    e.preventDefault();
                    this.open();
                }
                if (e.key === 'Escape' && this.searchOpen) {
                    this.close();
                }
            });

            // Ouverture programmatique depuis ailleurs
            window.addEventListener('open-site-search', () => this.open());

            // Fermer l'overlay avant toute navigation HTMX vers un lien
            document.addEventListener('htmx:beforeRequest', (e) => {
                if (!this.searchOpen) return;
                if (e.target?.tagName === 'A') {
                    this.close();
                }
            });
        },

        open() {
            this.searchOpen = true;
            document.body.style.overflow = 'hidden';
            this.$nextTick(() => {
                this.$refs.searchInput?.focus();
            });
        },

        close() {
            this.searchOpen = false;
            this.query = '';
            document.body.style.overflow = '';
        },

        clear() {
            this.query = '';
            this.$refs.searchInput?.focus();
            const box = document.getElementById('site-search-suggestions');
            if (box) box.innerHTML = '';
        },

        /**
         * Submit form (Enter) — redirige vers /recherche?q=...
         * Renommé "submitSearch" pour éviter tout conflit avec
         * HTMLFormElement.submit() natif.
         */
        submitSearch() {
            const q = this.query.trim();
            if (q.length < 2) return; // empty / 1 char → on ne fait rien

            this.pushRecent(q);

            const baseSearchUrl = window.SITE_SEARCH_URL || '/recherche';
            window.location.href = `${baseSearchUrl}?q=${encodeURIComponent(q)}`;
        },

        /**
         * Recherche depuis un terme récent
         */
        searchRecent(term) {
            this.query = term;
            this.submitSearch();
        },

        pushRecent(term) {
            this.recent = [term, ...this.recent.filter(t => t !== term)].slice(0, 6);
            try {
                localStorage.setItem('site_recent_searches', JSON.stringify(this.recent));
            } catch (e) { /* quota */ }
        },

        clearRecent() {
            this.recent = [];
            try { localStorage.removeItem('site_recent_searches'); } catch (e) {}
        },
    };
}